import { Adapter as r } from "../../../../adapter.js";
import { ShopSessionServiceModel as o } from "./service.model.js";
class i extends r {
  adapt(e) {
    return new o({
      numberPeople: e.number_people,
      channel: e.channel,
      readyAt: e.ready_at,
      type: e.type,
      now: e.now
    });
  }
  serialize(e) {
    throw new Error("Method not implemented.");
  }
}
export {
  i as ShopSessionServiceAdapter
};
//# sourceMappingURL=service.adapter.js.map
